import { feedlotManagerFeatures } from '../../apps/feedlotManager/featureFlags/feedlotManagerFeatures';

const { isCA13076On_OwnerActiveCheckboxFix } = feedlotManagerFeatures;

export const OWNER_INITIAL_STATE = {
    filter: {
        name: '',
        ownerId: 0,
        show: 'active',
    },
    createOwnerInitial: {
        name: '',
        contactNumber: '',
        email: '',
        address1: '',
        city: '',
        state: '',
        postalCode: '',
        totalHdCount: '',
        ...(isCA13076On_OwnerActiveCheckboxFix
            ? { isActive: true }
            : { active: true }),
    },
    loader: true,
};
